import MenuIcon from '@mui/icons-material/Menu'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import { getDwEnv } from '../lib/config'

import CalendlyPopup from '@components/CalendlyPopup'
import InstallNow from '@components/InstallNow'
import SupportButton from '@components/SupportButton'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { useMediaQuery } from '@mui/material'
import { keyframes, useTheme } from '@mui/material/styles'
import Logo from '../components/Logo'
import { useConciergeList } from '../hooks/useConciergeList'
import { useDrawer } from '../hooks/useDrawer'

export default function Header() {
  const { selectedConcierge } = useConciergeList()
  const conciergeId = selectedConcierge?.id ?? null

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ display: 'flex' }}>
        <BurgerMenu />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
          }}
        >
          <Logo />
        </Box>
        <EnvSign />
      </Box>
      <Box sx={{ display: 'flex', gap: 2 }}>
        {conciergeId && !selectedConcierge?.is_live && (
          <InstallNow conciergeId={conciergeId} />
        )}
        <CalendlyPopup />
        <SupportButton>
          <HelpOutlineOutlinedIcon />
        </SupportButton>
      </Box>
    </Box>
  )
}

const gentleGlow = keyframes`
  from {
    text-shadow:
      0 0 3px #fff,
      0 0 6px #fff,
      0 0 9px #bc13fe,
      0 0 12px #bc13fe;
  }
  to {
    text-shadow:
      0 0 2px #fff,
      0 0 4px #fff,
      0 0 6px #bc13fe,
      0 0 8px #bc13fe;
  }
`

function EnvSign() {
  const environment = getDwEnv()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  if (environment !== 'staging') return

  const displayText = isSmallScreen ? 'S' : 'Staging'
  const fontSize = {
    xs: '1rem',
    sm: '1.8rem',
  }
  const margin = {
    xs: '0.25rem',
    sm: '0.5rem',
  }
  const letterSpacing = {
    xs: '0.1em',
    sm: '0.15em',
  }

  return (
    <Box
      component='span'
      sx={{
        fontFamily: "'Segoe Script', 'Brush Script MT', cursive",
        fontSize,
        fontWeight: 400,
        color: 'grey.800',
        margin,
        letterSpacing,
        animation: `${gentleGlow} 3s infinite alternate`,
        userSelect: 'none',
        transform: 'rotate(-8deg)',
        textShadow: `
          0 0 2px rgba(0, 0, 0, 0.3),
          0 0 4px rgba(0, 0, 0, 0.2),
          0 0 6px rgba(0, 0, 0, 0.1),
          0 0 8px rgba(0, 0, 0, 0.1)
        `,
      }}
    >
      {displayText}
    </Box>
  )
}

function BurgerMenu() {
  const { handlerDrawerOpen } = useDrawer()

  return (
    <Avatar
      variant='rounded'
      sx={{
        mt: 1,
        overflow: 'hidden',
        transition: 'all .2s ease-in-out',
        color: 'grey.700',
        cursor: 'pointer',
        '&:hover': {
          bgcolor: 'transparent',
          color: 'common.black',
        },
      }}
      onClick={handlerDrawerOpen}
      color='inherit'
    >
      <MenuIcon />
    </Avatar>
  )
}
